<template>
    <div class="imgwall-row" :style="{justifyContent: spaceModifier}">
        <template v-for="item in images">
            <figure v-if="item.type === 'image'" :key="item.id">
                <img :src="item.src" alt="" class="imgwall-img" @load="resizeImage(item, $event)" :style="getStyleObject(item)">
            </figure>
            <div v-if="item.type === 'break'" class="imgwall-break" :key="item.id"></div>
        </template>
    </div>
</template>

<script>
export default {
    props: ["multiplier", "spaceModifier"],
    data: () => ({
        images: [
            {
                id: 1,
                type: "image",
                src: require("@/assets/placeholder.jpg")
            },
            {
                id: 2,
                type: "image",
                src: require("@/assets/placeholder.jpg")
            },
            {
                id: 3,
                type: "image",
                src: require("@/assets/placeholder.jpg")
            },
            {
                id: 4,
                type: "image",
                src: require("@/assets/placeholder.jpg")
            },
            {
                id: 5,
                type: "image",
                src: require("@/assets/placeholder.jpg")
            },
            {
                id: 6,
                type: "image",
                src: require("@/assets/placeholder.jpg")
            },
            {
                id: 7,
                type: "image",
                src: require("@/assets/placeholder.jpg")
            }
        ]
    }),
    methods: {
        resizeImage(image, event) {
            let aspectratio = event.target.naturalWidth / event.target.naturalHeight;

            image.maxWidth = this.multiplier * aspectratio;

            this.$set(this.images, this.images.findIndex(el => el.id === image.id), image);
        },
        getStyleObject(image) {
            let maxWidth = (image.maxWidth ? image.maxWidth + "px" : "0px");

            return {maxWidth}
        }
    }
}
</script>

<style lang="scss" scoped>
.imgwall-break {
  width: 100%;
}

img {
  display: block;
  width: 100%;
}

figure {
  margin: 0;
  height: 100%;
}

.imgwall-row {
  justify-content: space-between;
  align-items: center;
  display: flex;
  height: 100%;
  width: 100%;
}
</style>